import { JiraSiteAri } from '@atlassian/ari/jira/site';
import { fg } from '@atlassian/jira-feature-gating';
import { createAri } from '@atlassian/jira-platform-ari/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';

export const useSiteContextARI = () => {
	const cloudId = useCloudId();
	if (fg('migrate-jira-platform-ari-to-atlassian-ari')) {
		return JiraSiteAri.create({ siteId: cloudId }).toString();
	}
	return createAri({ resourceOwner: 'jira', resourceType: 'site', resourceId: cloudId });
};
